<template>
  <form>
    <div
      v-for="(interval, index) in form.intervals"
      :key="index + 1"
      class="form-row"
      :class="{ 'work-time': interval.plan_interval_type == 'work', 'absence-time': interval.plan_interval_type != 'work'}"
    >
      <div class="form-group col-sm-6">
        <div class="input-group">
          <select class="custom-select"
                  v-model="interval.plan_interval_type"
                  v-validate="'required'"
                  name="plan_interval_type"
          >
            <option
              v-for="(workIntervalType) in workIntervalTypes"
              :value="workIntervalType.key"
              :key="workIntervalType.key"
              v-if="canShowAbsenceTypeItem(workIntervalType)"
            >
              {{ workIntervalType.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group col-sm-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fal fa-fw fa-clock"></i></span>
          </div>
          <datetime
            v-model="interval.from"
            :config="timePickerConfig"
            v-validate="'date_format:mm:ss'"
            class="flatpickr"
            @focusout.native="sortIntervals"
            name="from"
          />
        </div>
      </div>

      <div class="form-group col-sm-3">
        <div class="input-group">
          <datetime
            v-model="interval.to"
            :config="timePickerConfig"
            v-validate="'date_format:mm:ss'"
            class="flatpickr"
            name="to"
          />
          <div class="input-group-append">
            <span class="input-group-text"><i class="fal fa-fw fa-clock"></i></span>
          </div>
        </div>
      </div>

<!--      <div class="form-group col-sm-1">
        <button
          @click="removeInterval(index)"
          type="button"
          class="btn btn-danger btn-remove-interval"
          :disabled="form.intervals.length == 1"
        >
          <i class="fal fa-minus"></i>
        </button>
      </div>-->

    </div>

<!--    <button
      @click="addInterval()"
      type="button"
      class="btn btn-info btn-repeater"
      :disabled="validateIntervals()"
    >
      <i class="fal fa-plus"></i>
    </button>-->

<!--    <span class="badge badge-interval badge-success float-right">
      {{ intervalLength() }}
    </span>-->
  </form>
</template>


<script>
const userLanguage = document.documentElement.lang;

export default {
  name: 'shift-plan-embed-form',
  data: function() {
    return {
      url: null,
      date: null,
      form: {
        intervals: []
      },
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        enableSeconds: false,
        dateFormat: 'H:i',
        defaultHour: 8,
        defaultMinute: 0,
        locale: userLanguage
      }
    }
  },

  props: {
    'workIntervalTypes': {
      type: Array
    },
    'defaultFormData': {
      type: Object
    },
    'contractSettings': {
      type: Object
    },
    'trans': {
      type: Object
    },
    'defaultInterval': {
      type: Object
    },
  },

  created() {
    this.form = this.defaultFormData;

    this.sortIntervals();
  },

  methods: {
    addInterval() {
      const lastInterval = this.form.intervals[this.form.intervals.length - 1];

      if (!lastInterval) {
        this.form.intervals.push({
          ...this.defaultInterval
        })
        return;
      }

      let mmtLastIntervalFrom = moment(lastInterval.from,'kk:mm');
      let mmtLastIntervalTo = moment(lastInterval.to,'kk:mm');

      if(mmtLastIntervalTo.unix() < mmtLastIntervalFrom.unix()) {
        mmtLastIntervalTo = mmtLastIntervalTo.add(1, 'day');
      }

      let lastIntervalRange = moment.range(mmtLastIntervalFrom, mmtLastIntervalTo);
      let lastIntervalLength = Math.abs( lastIntervalRange.diff('hours') ) + ( Math.abs(lastIntervalRange.diff('minutes')) - Math.abs(lastIntervalRange.diff('hours')*60) ) / 60;

      let remainingShiftLength = this.dailyWorkingFund - lastIntervalLength;
      if(remainingShiftLength < 0) remainingShiftLength = 1;

      let breakLength = 0.5; // h
      let nextFrom = moment(lastInterval.to, 'kk:mm').add(breakLength, 'h').format('kk:mm');
      let nextEnd = moment(nextFrom, 'kk:mm').add(remainingShiftLength, 'h').format('kk:mm');

      this.form.intervals.push({
        ...this.defaultInterval,
        plan_interval_type: 'work',
        from: nextFrom,
        to: nextEnd
      });
    },

    removeInterval(index) {
      this.$delete(this.form.intervals, index);
    },

    intervalLength() {
      let totalSec = 0;

      this.form.intervals.forEach( interval => {
        let t1 = moment(interval.from, "hh:mm").diff(moment().startOf('day'), 'seconds');
        let t2 = moment(interval.to, "hh:mm").diff(moment().startOf('day'), 'seconds');

        totalSec += (t2 - t1);
      });

      return moment().startOf('day').seconds(totalSec).format('HH:mm') + ' ' + 'h.';
    },

    validateIntervals() {
      const timeFormat = 'HH:mm';
      const intervals = this.form.intervals;
      const arrLength = intervals.length;
      let intervalIsOverlaid = false;

      if (arrLength == 1) return;

      for (let i = 0; i < arrLength - 1; i++) {
        let t1 = intervals[i],
          t1_from = t1.from,
          t1_to = t1.to;

        let t2 = intervals[i + 1],
          t2_from = t2.from,
          t2_to = t2.to;

        intervalIsOverlaid = moment(t2_from, timeFormat).isBetween( moment(t1_from, timeFormat), moment(t1_to, timeFormat) )
          || moment(t2_to, timeFormat).isBetween( moment(t1_from, timeFormat), moment(t1_to, timeFormat) )
        //|| t1_from > t1_to
        ;
      }

      return intervalIsOverlaid;
    },

    getData() {
      return this.form;
    },

    formatHolidaySelectOptionDate(val) {
      return moment(val).format('DD.MM.YYYY');
    },

    canShowAbsenceTypeItem(workDayType) {
      return workDayType.key != 'nvp-holiday' && workDayType.key != 'holiday-not-worked'/* ||
        workDayType.key == 'nvp-holiday' && this.contractSettings.workedHolidayCompensationClaim == 1 ||
        workDayType.key == 'holiday-not-worked' && this.contractSettings.calculateWorkFundWithHoliday == 1*/;
    },

    holidaySelectChanged(evt, interval, index) {
      const foundWH = this.workedHolidays.find(x => x.id == evt.srcElement.value);

      if(foundWH) {
        let workedHolidayHours = foundWH.length;

        if(index == 0) {
          interval.from = moment().hours(7).minutes(0).seconds(0).format('kk:mm');
        }
        else {
          interval.from = moment(this.getSortedIntervals[index-1].to, 'kk:mm').format('kk:mm');
        }

        interval.to = moment(interval.from, 'kk:mm').add(workedHolidayHours, 'h').format('kk:mm');
      }
    },

    timeToNumber(time) {
      let t = moment(time, "HH:mm").diff(moment().startOf('day'), 'minutes');

      // if night shift (24:00 - 04:59) - because of sorting intervals
      if (t >= 0 && t < 300) return t += 1440;

      else return t;
    },

    sortIntervals() {
      this.form.intervals = this.form.intervals.sort( (a, b) => this.timeToNumber(a.from) < this.timeToNumber(b.from) ? -1 : 1 );
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/shift-plan/modals/ShiftPlanEmbedForm.vue